import { Outlet, useLocation } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'
import { MobileNav } from './MobileNav'
import { MobileMenuDrawer } from './MobileMenuDrawer'
import { ScrollToTop } from './ScrollToTop'
import { GlobalSearchDrawer } from '@/components/search/GlobalSearchDrawer'
import { WhatsAppFloat } from '@/components/layout/WhatsAppFloat'
import { BackToTopButton } from '@/components/layout/BackToTopButton'
import { AuthModal } from '@/components/auth/AuthModal'
import { RouteSeoFallback } from '@/components/RouteSeoFallback'
import { cn } from '@/lib/utils'

export function AppLayout() {
  const { pathname } = useLocation()
  const isPropertyDetail = pathname.startsWith('/property/')
  const isMagazineReader = /^\/magazine\/[^/]+/.test(pathname)

  return (
    <div className="flex min-h-screen flex-col">
      <RouteSeoFallback />
      <ScrollToTop />
      <Header />
      <GlobalSearchDrawer />
      <MobileMenuDrawer />
      <AuthModal />
      <WhatsAppFloat />
      <BackToTopButton />
      <main
        className={cn(
          'flex-1 overflow-x-clip bg-page md:pb-0',
          isPropertyDetail || isMagazineReader ? 'pb-0' : 'pb-20',
        )}
      >
        <Outlet />
      </main>
      <Footer />
      <MobileNav />
    </div>
  )
}
